import { LOGGER_SEVERITY } from './logger-severity';

type Severity = (typeof LOGGER_SEVERITY)[keyof typeof LOGGER_SEVERITY];

/** Lower number = more verbose. Unknown / unset `LOG_LEVEL` → no filtering. */
const RANK: Record<Severity, number> = {
  [LOGGER_SEVERITY.DEBUG]: 10,
  [LOGGER_SEVERITY.INFO]: 20,
  [LOGGER_SEVERITY.LOG]: 30,
  [LOGGER_SEVERITY.WARN]: 40,
  [LOGGER_SEVERITY.ERROR]: 50,
};

const VALID = new Set<string>(Object.values(LOGGER_SEVERITY));

/** Parse `LOG_LEVEL`. Empty / unknown → `null` (emit everything). */
export const parseLogLevel = (raw: string | undefined): Severity | null => {
  if (raw === undefined) return null;
  const normalized = raw.trim().toLowerCase();
  if (!normalized || !VALID.has(normalized)) return null;
  return normalized as Severity;
};

/** Current threshold from the environment, or `null` when unset/invalid. */
export const configuredLogLevel = (): Severity | null => parseLogLevel(process.env.LOG_LEVEL);

/**
 * Whether a message at `severity` should be emitted under `LOG_LEVEL`.
 * Unset / invalid level → always true (today's behavior).
 */
export const shouldLog = (
  severity: Severity,
  level: Severity | null = configuredLogLevel(),
): boolean => {
  if (level === null) return true;
  return RANK[severity] >= RANK[level];
};
